export const LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS: Record<
	string,
	`onboarding-live-doc-changeboarding:${string}`
> = {
	hasDismissedIntroSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
	hasDismissedLiveDocTour: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
	hasDismissedLiveDocModal: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
	hasDismissedContentWrapperTour:
		'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
	hasDismissedAiButtonTour: 'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
	hasDismissedConvertToPageSpotlight:
		'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight',
} as const;
